import api from "./api";

export type GenerationAnalysisType = 'monthly' | 'annual';

export type GenerationAnalysisPoint = {
    date: string;
    generation: number | null;
    prognosis: number;
    consumption: number | null;
};

export type GenerationAnalysisMonth = {
    month: string;
    daysInMonth: number;
    generation: number;
    prognosis: number;
    consumption: number | null;
    performance: number | null;
    generationSource: 'reportGeneration' | 'reportDetailed' | 'charts' | 'none';
    hasGenerationReport: boolean;
    hasDetailedReport: boolean;
    dailyAvailable: boolean;
    consumptionCoveredDays: number;
    generationInConsumptionPeriod: number | null;
    balance: number | null;
};

export type GenerationAnalysis = {
    plant: { id: string; name: string };
    type: GenerationAnalysisType;
    start: string;
    end: string;
    granularity: 'day' | 'month';
    chartsSource: 'influx' | 'portal' | 'none';
    points: GenerationAnalysisPoint[];
    months: GenerationAnalysisMonth[];
    totals: {
        generation: number;
        prognosis: number;
        consumption: number | null;
        performance: number | null;
        balance: number | null;
        coverage: number | null;
        monthsWithConsumption: number;
        monthsTotal: number;
    };
};

export const getGenerationAnalysis = async (plant: string, type: GenerationAnalysisType, start: string, end: string): Promise<GenerationAnalysis> => {
    const response = await api.get(`reports/generationAnalysis?plant=${plant}&type=${type}&start=${start}&end=${end}`);
    return response.data;
};
